module.exports = __webpack_public_path__ + "img/Camera.477f3661.svg";